import { render, staticRenderFns } from "./photo-select.vue?vue&type=template&id=745ff09f&scoped=true&"
import script from "./photo-select.vue?vue&type=script&lang=js&"
export * from "./photo-select.vue?vue&type=script&lang=js&"
import style0 from "./photo-select.vue?vue&type=style&index=0&id=745ff09f&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ff09f",
  null
  
)

export default component.exports